export default __webpack_public_path__ + "static/media/insta.6c5a2827.svg";